import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { FileServiceService } from '../service/file-service.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {

  date: Date | undefined;

  constructor(private route: Router, public service: FileServiceService) { }

  ngOnInit(): void {
    this.date = new Date();
    if (this.service.getCache('files')) {
      this.service.referenceFileDetails.files = this.service.getCache('files');
    }
    this.route.events.subscribe(event=>{
        if(event instanceof NavigationStart && event.navigationTrigger === "popstate" ){
          this.exit();
        }
    })

  }

  exit() {
    this.service.reset();
    this.service.clearCache();
    let url = window.localStorage.getItem('securityCode');
    this.route.navigate(['/' + url]);
  }

}
